import { CLEAR_RECOMMENDATIONS } from './actionTypes';

const clearRecommendations = () => ({ type: CLEAR_RECOMMENDATIONS });

export default clearRecommendations;
